(ns hypnos.dme.tile.field.referral-therapist
  "Field for consult therapist/user."
  (:require [hypnos.i18n :refer [tr]]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Field

(defn field
  ([state]
   (field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   (let [org  (rf/subscribe [:dme/organization])
         user (rf/subscribe [:dme/user])]
     [:div.field.is-horizontal
      [:div.field-label.is-normal
       [:label.label (tr :ui.label/therapist)]]
      [:div.field-body
       [:div.field.is-narrow
        [:div.control
         [:div.select.is-fullwidth
          [:select
           {:type     :text
            :disabled disabled
            :value    (if-let [val (get-in @state [:patient :patient/last-consult :consult/user :value])]
                        val
                        (if disabled "" (:user/id @user)))
            :on-change (fn [e]
                         (let [old-value (get-in @state [:patient :patient/last-consult :consult/user :value])
                               new-value (-> e .-target .-value)
                               changed?  (or (get-in @state [:patient :patient/last-consult :consult/user :dirty?])
                                             (not= new-value old-value))]
                           (swap! state assoc-in [:patient :patient/last-consult :consult/user :value] new-value)
                           (swap! state assoc-in [:patient :patient/last-consult :consult/user :dirty?] changed?)))
            :on-focus  (fn [_]
                         (swap! state assoc-in [:patient :patient/last-consult :consult/user :touched?] true))}
           (for [user (:user/_organizations @org)]
             [:option {:key (:user/id user) :value (:user/id user)} (str (:user/first-name user) " " (:user/last-name user))])]]]
        (when-not disabled [:p.help (tr :ui.help/therapist)])]]])))
